module.exports = __webpack_public_path__ + "img/1209601557.ac6d0018.jpg";